import axios from "axios";

const url=process.env.REACT_APP_BACKEND_URL

export const FetchUserAccessLocation=async(setIsLoading,setData,handleErrorOpen)=>{
    try{
        setIsLoading(true);
        await axios.get(`${url}/auth/get_user_data`,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
        .then((response)=>{
            setIsLoading(false);
            setData(response.data)
        })
    }
    catch(error){
        setIsLoading(false);
        handleErrorOpen(error.response?error.response.data.error:"Something went wrong","error");
    }
}